import { PPT_TO_PDF_TOOL } from '@quicktools/shared-components';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = PPT_TO_PDF_TOOL.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const RECAPTCHA_SITE_KEY = process.env.NX_RECAPTCHA_SITE_KEY;
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const QUICKTOOLS_API_BASE_URL = process.env.NX_QUICKTOOLS_API_BASE_URL;

export const canonicalPath = 'convert/ppt-to-pdf/';

export const appConfig = {
  accept:
    'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
  multiple: false,
  logoUrl: 'https://cdn140.picsart.com/15540464356696557916.svg',
  heroBannerImgUrl: 'https://cdn140.picsart.com/29503185622175896831.webp',
  heroBannerImgAlt: 'convert ppt to pdf online',
  appImage: 'https://cdn140.picsart.com/29503185622175896831.webp',
} as const;

export const UPLOADING_ICON_URL = 'https://cdn140.picsart.com/02927750710693585619.svg';
export const PPT_ICON_URL = 'https://cdn140.picsart.com/07180280572001978024.svg';
